var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EditIcon_svg__clip0_602_44783)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.548.777l-10.16 10.16a4.137 4.137 0 00-1.22 2.946v1.119a.833.833 0 00.833.833h1.12a4.138 4.138 0 002.945-1.22l10.16-10.16a2.604 2.604 0 000-3.678 2.662 2.662 0 00-3.678 0zm2.5 2.5l-10.16 10.16c-.47.467-1.105.73-1.768.731h-.285v-.285a2.517 2.517 0 01.731-1.768l10.16-10.16a.957.957 0 011.322 0 .936.936 0 010 1.322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.167 7.482a.833.833 0 00-.834.834V12.5H15a2.5 2.5 0 00-2.5 2.5v3.333H4.167a2.5 2.5 0 01-2.5-2.5V4.167a2.5 2.5 0 012.5-2.5h7.535a.833.833 0 000-1.667H4.167A4.172 4.172 0 000 4.167v11.666A4.172 4.172 0 004.167 20h9.452a4.14 4.14 0 002.947-1.22l2.213-2.215A4.14 4.14 0 0020 13.619V8.316a.833.833 0 00-.833-.834zm-3.78 10.12a2.48 2.48 0 01-1.22.666V15a.834.834 0 01.833-.833h3.27a2.514 2.514 0 01-.666 1.22l-2.216 2.215z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EditIcon_svg__clip0_602_44783"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};

export default SvgEditIcon;